module.exports = __webpack_public_path__ + "35d92744bbd8dca6fe7d3dc33df076c2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/sofas/sofa-winter.png
// module id = 997
// module chunks = 0